import React from 'react';
import { TextInput, Button, Asset, Table,TableHead, TableRow, TableBody, TableCell, Tab, Switch, SelectField, Option } from '@contentful/forma-36-react-components';
import { DialogExtensionSDK } from 'contentful-ui-extensions-sdk';
import debounce from 'lodash.debounce';
import Client from './client';
import { AppInstallationParameters } from './ConfigScreen';
import { timingSafeEqual } from 'crypto';
import { throws } from 'assert';
import { link } from 'fs';
import { visitParameterList } from 'typescript';
import { CliplisterResult, CliplisterTemplateVar } from '../typings';

interface Props {
  sdk: DialogExtensionSDK;
}

interface State {
  searchValue: string;
  client: Client;
  customerID: string;
  error: boolean;
  photos: CliplisterResult[];
  detailsActive : boolean;
  selectedAsset: CliplisterResult[];
  preview: boolean;
  displayList: boolean;
  searchFilter: string;
}

export default class Dialog extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    //@ts-ignore
    const parameters: AppInstallationParameters = this.props.sdk.parameters.installation;

    // console.log("PARAMETERS", this.props.sdk.parameters.installation);
    //var parameters = this.props.sdk.parameters.installation;
    
    this.state = {
      searchValue: '',
      client: new Client(parameters.cliplisterApiToken || ''),
      customerID: parameters.cliplisterCustomerID,
      error: false,
      photos: [],
      selectedAsset: [],
      detailsActive: false,
      preview: false,
      displayList: true,
      searchFilter: ''
    };
  }

  componentDidMount() { 
    this.props.sdk.window.startAutoResizer();
    this.onSearch("");
    const script = document.createElement("script");
    script.src = "https://mycliplister.com/merge?cliplister=1.11&clviewer=1.37&videostage=1.25&clickablevideo=1.6&innercontrols=1.11&previewimage=1.4&playbutton=1.1&playbutton=1.2&clzoom=1.1&clstagepdf=1.10&pdfcontrols=1.9";
    //script.src = " https://mycliplister.com/merge?cliplister=1.6&clviewer=1.21&clzoom=1.1&clstagepdf=1.10&pdfcontrols=1.9";
    script.async = true;
    document.body.appendChild(script);
  }
  formatPhotoThumb(photo: CliplisterResult) {

    //@ts-ignore
    const parameters: AppInstallationParameters = this.props.sdk.parameters.installation;


    console.log("PARAMETERS", parameters.cliplisterSourceUrl);
    if(photo.kind == "template"){
      return "https://template.mycliplister.com/isaclte/"+this.state.customerID+"/c3/-/-/"+photo.uuid+"?x=300&quality=80";
    }else{
      return parameters.cliplisterSourceUrl+photo.uuid+"?x=300&quality=80";
    }
    
    //return url.replace('fit=max', 'fit=fillmax').concat('&w=300&h=300');
  }
  formatPhotoThumbLarge(photo: CliplisterResult) {

    //@ts-ignore
    const parameters: AppInstallationParameters = this.props.sdk.parameters.installation;


    console.log("PARAMETERS", parameters.cliplisterSourceUrl);
    if(photo.kind == "template"){
      return "https://template.mycliplister.com/isaclte/"+this.state.customerID+"/c3/-/-/"+photo.uuid+"?x=900&quality=80";
    }else{
      return parameters.cliplisterSourceUrl+photo.uuid+"?x=900&quality=80";
    }
    
    //return url.replace('fit=max', 'fit=fillmax').concat('&w=300&h=300');
  }


  generateTemplateUrl(){
    let linkAppend = "?";

    this.state.selectedAsset[0].templateJson.variables.map((variable)=>{
      if("value" in variable && variable.value != ""){
        // @ts-ignore
        linkAppend = linkAppend+variable.name +"="+encodeURIComponent(variable.value)+"&"
      }
    }) 


    linkAppend = linkAppend + "x="+this.state.selectedAsset[0].templateJson.defaultSettings.width;

    return "https://template.mycliplister.com/isaclte/"+this.state.customerID+"/c3/-/-/"+this.state.selectedAsset[0].uuid+linkAppend;
  }


  changeTemplateWidth(value: string){
    var selectedAsset = this.state.selectedAsset;
    selectedAsset[0].templateJson.defaultSettings.width = value;

    this.setState({selectedAsset})
  }
  changeAssetTitle(value: string){
    var selectedAsset = this.state.selectedAsset;
    selectedAsset[0].title = value;

    this.setState({selectedAsset})
  }
  changeAssetDescription(value: string){
    var selectedAsset = this.state.selectedAsset;
    selectedAsset[0].description = value;

    this.setState({selectedAsset})
  }
  changeVariable(value: string, variable: CliplisterTemplateVar){
    var selectedAsset = this.state.selectedAsset;
    const index = selectedAsset[0].templateJson.variables.map(e => e.name).indexOf(variable.name);
    selectedAsset[0].templateJson.variables[index].value = value;
    console.log(variable);
    this.setState({selectedAsset})
  }
  onSearch = debounce(async (value: string) => {
    /*if (!value) {
      this.setState({ photos: [] });
      return;
    }*/
    this.setState({searchValue: value});

    const res = await this.state.client.search(value, this.state.searchFilter);

    this.setState({
      error: res.error,
      photos: res.photos
    });
  }, 300);


  onAssetLoadDetails = debounce(async (uniqueId: string) => {
    /*if (!value) {
      this.setState({ photos: [] });
      return;
    }*/

    const res = await this.state.client.getAssetDetails(uniqueId);
    console.log(res.singleAsset);
    if(res.singleAsset[0].kind == "template"){
      this.setState({detailsActive: true, selectedAsset: res.singleAsset});
    }else{
      this.setState({preview: true, selectedAsset: res.singleAsset});
    }
  }, 300);


  save = (photo: CliplisterResult) => {
    this.props.sdk.close(photo);
  };
  toggleListAsset = () =>{
    if(this.state.displayList == true){
      this.setState({displayList: false});
    }else{
      this.setState({displayList: true});
    }
  }
  loadVideo = (videoUUID: string)=>{

    
    const script_player = document.createElement("script");
    script_player.type = "text/javascript";
    script_player.async = false;
    script_player.text = 'var myViewer = new Cliplister.Viewer({\
      parentId: "video-viewer",\
      customer: '+this.state.customerID+',\
      assets: ["'+videoUUID+'"],\
      keyType: 30000,\
      forceSSL: true,\
      plugins: {\
        InnerControls: {\
            layer: 2,\
            id: "controls",\
            blacklist: ["share","quality","playback-speed"],\
            template: {\
                type: "external",\
                source: "https://mycliplister.com/static/viewer/assets/skins/default/controls.html"\
            }\
        },\
        PlayButton: {\
          id: "playButton",\
          layer: 5,\
          image: "https://mycliplister.com/static/viewer/assets/skins/default/playButton.png",\
          width: 100,\
          height: 100\
        },\
        ClickableVideo: {\
          layer: 1\
        },\
        PreviewImage: {\
          layer: 4\
        }\
      }\
    });';

    setTimeout(() => {
      document.body.appendChild(script_player);
    },1000);

  }
  updateSearchFilter = debounce(async (e: string)=>{
    console.log(e);
    this.setState({searchFilter: e});

    const res = await this.state.client.search(this.state.searchValue, e);

    this.setState({
      error: res.error,
      photos: res.photos
    });
  })
  loadPdf = (videoUUID: string)=>{
    const script_player = document.createElement("script");
    script_player.type = "text/javascript";
    script_player.async = false;
    script_player.text = 'var myViewer = new Cliplister.Viewer({\
      parentId: "video-viewer",\
      customer: '+this.state.customerID+',\
      assets: ["'+videoUUID+'"],\
      keyType: 30000,\
      dev: true,\
      assetType: "pdf",\
      slot: 10,\
      backgroundColor: "white",\
      stage: {width: "100%", aspectRatio: "asset", animated: "slide"},\
      plugins:{\
        PDFControls: {\
            template: "https://mycliplister.com/static/viewer/assets/skins/default/controls-pdf-210217.html",\
            layer: 3,\
            hide: false,\
            overlayViewer: false,\
            zoomMode: "CLZoom",\
        },\
        CLZoom: {\
            layer: 2,\
            maxZoomScale: 3,\
            zoomLevels: 2,\
            tileSize: 250,\
            template: false,\
        }}\
      });';
      setTimeout(() => {
        document.body.appendChild(script_player);
        console.log("added");
      },1000);
  }
  render() {
    const { photos } = this.state;
    const displayList = this.state.displayList;
    return (
      <div>
        <div>
        {(this.state.detailsActive == false && this.state.preview == false) &&
        <div className="searchFieldCliplister">
          <TextInput
            width="full"
            type="text"
            id="my-field"
            testId="my-field"
            placeholder="Suche..."
            autoComplete="off"
            value={this.state.searchValue}
            onChange={(e:any) => this.onSearch(e.currentTarget.value)}
          />
          </div>
        }
        </div>
        {this.state.preview != true &&
          <div className="listSwitch">
            <Switch id="testSwitch" onToggle={()=> this.toggleListAsset()} isChecked={displayList} labelText="Listenansicht" />
          </div>
        }
        {this.state.preview != true &&
        <div className="optionSelectCliplister">
          <SelectField
            name="optionSelect"
            id="selectFilter"
            labelText=""
            onChange={(e:any)=>this.updateSearchFilter(e.currentTarget.value)}
          >
            <Option value="">Alle Formate</Option>
            <Option value="picture">Bilder</Option>
            <Option value="video">Videos</Option>
            <Option value="pdf">PDF</Option>
            <Option value="audio">Audio</Option>
            <Option value="3d">3D Assets</Option>
            <Option value="template">Templates</Option>
          </SelectField>
          </div>
        }
        {(this.state.detailsActive == false && this.state.preview == false && displayList == false) &&
        <div className="search-collection">
          {photos.map((photo)=> {
            console.log(photo.fileExt);
            return(
                <div key={photo.uuid} className="photo">
                  {photo.fileType == "Video" &&
                    <div  onClick={() => this.save(photo)}>
                    <Asset src={this.formatPhotoThumb(photo)} type="video" title={photo.title} />
                    </div>
                  }
                  {photo.fileType == "Picture" &&
                    <div  onClick={() => this.onAssetLoadDetails(photo.uniqueId)}>
                    <Asset src={this.formatPhotoThumb(photo)} type="image" title={photo.title} />
                    </div>
                  }
                  {photo.kind == "3Dasset" &&
                    <div  onClick={() => this.save(photo)}>
                    <Asset src={this.formatPhotoThumb(photo)} type="markup" title={photo.title} />
                    </div>
                  } 
                  {photo.kind == "template" &&
                    <div  onClick={() => this.onAssetLoadDetails(photo.uniqueId)}>
                    <Asset src={this.formatPhotoThumb(photo)} type="image" title={photo.title} />
                    </div>
                  }
                  {photo.fileExt == "mp3" &&
                    <div  onClick={() => this.onAssetLoadDetails(photo.uniqueId)}>
                    <Asset src={this.formatPhotoThumb(photo)} type="audio" title={photo.title} />
                    </div>
                  }
                  {photo.fileExt == "pdf" &&
                    <div  onClick={() => this.onAssetLoadDetails(photo.uniqueId)}>
                    <Asset src={this.formatPhotoThumb(photo)} type="pdf" title={photo.title} />
                    </div>
                  }
                </div>
            )
          })}
        </div>
        }
        {(this.state.detailsActive == false && this.state.preview == false && displayList == true) &&
        <div className="search-collection">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Preview</TableCell>
              <TableCell>Titel</TableCell>
              <TableCell>Type</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
          {photos.map((photo)=> {
                  
            if(photo.fileType == "Video" || photo.kind == "3Dasset" || photo.fileExt == "mp3" || photo.fileExt == "pdf"){
              return(
                  <TableRow key={photo.uuid} >
                            <TableCell>
                            {photo.fileType == "Video" &&
                                <svg className="Illustration__Illustration___1R5Px " xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"><path d="M20.5 23.5h-17V.5h11l6 6z"></path><path d="M14.5.5v6h6M8.5 8.5l8 5-8 5z"></path></g></svg>
                              }
                              {photo.kind == "3Dasset" &&
                                <svg data-test-id="cf-ui-asset-icon" className="Illustration__Illustration___1R5Px " viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"><g fill="none" stroke="#000"><path d="M20.688 23.492h-17v-23h11l6 6v17z"></path><path d="M14.688.492v6h6M14.688 10.492l4 4-4 4M9.688 10.492l-4 4 4 4"></path></g></svg>
                              } 
                              {photo.fileExt == "mp3" &&
                                <svg data-test-id="cf-ui-asset-icon" className="Illustration__Illustration___1R5Px" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"><path d="M9 12.5H7.25a.75.75 0 0 0-.75.75v1.5c0 .414.336.75.75.75H9l3.5 3.5V9L9 12.5zM16 11c.834.688 1.5 1.835 1.5 3 0 1.163-.669 2.312-1.5 3M14 12.25c.562.409 1 1.001 1 1.75 0 .749-.438 1.341-1 1.75"></path><path d="M21.5 23.5h-19V.5h13l6 6z"></path><path d="M15.5.5v6h6"></path></g></svg>
                              }
                              {photo.fileExt == "pdf" &&
                                <svg data-test-id="cf-ui-asset-icon" className="Illustration__Illustration___1R5Px" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"><path d="M15.5.5v6h6"></path><path d="M21.5 23.5h-19V.5h13l6 6z"></path><path d="M11.5 18.5v-5h1c1.152 0 2 1.068 2 2.5s-.848 2.5-2 2.5h-1zM16.5 18.5v-5H19M16.5 15.5H18M6.5 18.499V13.5h1.25a1.25 1.25 0 1 1 0 2.5H6.5"></path></g></svg>
                              }
                            </TableCell>
                            <TableCell>{photo.title}</TableCell>
                            <TableCell>{photo.fileType}</TableCell>
                            <TableCell>
                              <Button icon="Plus" onClick={() =>this.onAssetLoadDetails(photo.uniqueId)}>
                                
                              </Button>
                            </TableCell>
                        </TableRow>
              )
            }else if(photo.kind == "template" || photo.fileType == "Picture"){
              return(

                      <TableRow key={photo.uuid} >
                          <TableCell><img className="cl-preview-list"  src={this.formatPhotoThumb(photo)}></img></TableCell>
                          <TableCell>{photo.title}</TableCell>
                          <TableCell>{photo.fileType}</TableCell>
                          <TableCell>
                            <Button icon="Plus" onClick={() => this.onAssetLoadDetails(photo.uniqueId)}>
                              
                            </Button>
                          </TableCell>
                      </TableRow>
              )}
          })}
          </TableBody>
        </Table>
        </div>
        }
        {this.state.preview == true &&
          <div className="clCustHolder">
            <Button buttonType="muted" icon="ChevronLeft" className="cliplisterButton leftTop" onClick={()=>this.setState({preview: false})}>Zurück</Button>
            <h3>Asset: {this.state.selectedAsset[0].title}</h3>
            <Button className="cliplisterButton rightTop" icon="Plus" onClick={()=>this.save(this.state.selectedAsset[0])}>Einfügen</Button>
            <p>Titel:</p>
            <TextInput
              width="full"
              type="text"
              id="my-field"
              testId="my-field"
              style={{marginTop: "10px"}}
              placeholder="Title"
              value={this.state.selectedAsset[0].title}
              onChange={(e:any) => this.changeAssetTitle(e.target.value)}
            /> 
            <p>Description:</p>
            <TextInput
              width="full"
              type="text"
              id="my-field"
              testId="my-field"
              style={{marginTop: "10px"}}
              placeholder="Description"
              value={this.state.selectedAsset[0].description}
              onChange={(e:any) => this.changeAssetDescription(e.target.value)}
            /> 
            <p>Preview:</p>
            {this.state.selectedAsset[0].fileType == "Video" &&
            <div id="video-viewer" className={"templateHolder large "+this.loadVideo(this.state.selectedAsset[0].uuid)}></div>
            }
            {this.state.selectedAsset[0].fileType == "Document" &&
            <div id="video-viewer" className={"templateHolder large "+this.loadPdf(this.state.selectedAsset[0].uuid)}></div>
            }


            {this.state.selectedAsset[0].fileType != "Video" && this.state.selectedAsset[0].fileType != "Document" &&
            <div className="templateHolder large" style={{backgroundImage: "url("+this.formatPhotoThumbLarge(this.state.selectedAsset[0])}}></div>
            }
            <div className="CLspacer"></div>
          </div>
        }
        {this.state.detailsActive == true &&
        <div className="clCustHolder">
          <h3>{this.state.selectedAsset[0].title}</h3>
          <Button className="cliplisterButton rightTop" onClick={()=>this.save(this.state.selectedAsset[0])}>Einfügen</Button>
            <p>Template Einstellungen:</p>
          {this.state.selectedAsset[0].templateJson.variables.map((variable)=>{
            let type = "text";

            if(variable.parameter == "backgroundColor"){

              return(
                <div>
                  <p>{variable.layer+" "+variable.parameter}</p>
                <input
                width="full"
                type="color"
                id="my-field"
                style={{marginTop: "10px"}}
                onChange={(e:any) => this.changeVariable(e.target.value, variable)}
              />
              </div>
              )
            }else{

            return(
              <TextInput
              width="full"
              type="text"
              id="my-field"
              testId="my-field"
              style={{marginTop: "10px"}}
              onChange={(e:any) => this.changeVariable(e.target.value, variable)}
              placeholder={variable.layer+" "+variable.parameter}
            />  
            )
            }
          })}
          <br></br>
          <p>Preview Optionen:</p>
            <TextInput
              width="full"
              type="text"
              id="my-field"
              testId="my-field"
              style={{marginTop: "10px"}}
              placeholder="Template Width"
              onChange={(e:any) => this.changeTemplateWidth(e.target.value)}
            />  
          <div className="templateHolder" style={{backgroundImage: "url("+this.generateTemplateUrl()}}></div>
        </div>
        }
      </div>
    );
  }
}